/**
 * Query keys centralizzate per le query TanStack Query relative alla ricezione merci.
 * Usa questa struttura per garantire invalidazione consistente della cache.
 */
export const goodsReceivingQueryKeys = {
  all: ['goods-receiving'] as const,
  suppliers: () => ['goods-receiving', 'suppliers'] as const,
  productNames: () => ['goods-receiving', 'product-names'] as const,
  notes: () => ['goods-receiving', 'notes'] as const,
  notesByDateRange: (from: string, to: string, page = 1) =>
    ['goods-receiving', 'notes', from, to, page] as const,
  noteDetail: (id: string) => ['goods-receiving', 'notes', id] as const,
  drafts: () => ['goods-receiving', 'drafts'] as const,
  draft: (id: string) => ['goods-receiving', 'draft', id] as const,
  recallMatches: (id: string, itemCount: number) =>
    ['goods-receiving', 'recall-matches', id, itemCount] as const,
  presignedUrl: (storageKey: string) => ['goods-receiving', 'presigned-url', storageKey] as const,
  storageSuggestions: (draftId: string) =>
    ['goods-receiving', 'storage-suggestions', draftId] as const,
};
